var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7088 1.91L12.2988 0.5L6.29883 6.5L12.2988 12.5L13.7088 11.09L9.12883 6.5L13.7088 1.91ZM7.70883 1.91L6.29883 0.5L0.298828 6.5L6.29883 12.5L7.70883 11.09L3.12883 6.5L7.70883 1.91Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLeftBlack);
export default __webpack_public_path__ + "static/media/page-left-black.18473f33cd7a0f666fde236b5e3ca46b.svg";
export { ForwardRef as ReactComponent };